import { useQuery } from "@tanstack/react-query";

import { courtsApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useCourts() {
  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.Courts],
    queryFn: () => courtsApi.getAllCourts(),
    meta: { loadingScope: "pageContent" },
  });

  return { courts: data ?? [], isLoading };
}
